import React, { useState, useRef, useEffect } from 'react';

const SearchBarPublished = ({ totalPositions, setPublished, totalPositionsLength, positionLabel, searchLabel, autoFocus, loading, updateWebsites, handleRunMonitoringScan, handleRunSecurityScan }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const inputRef = useRef(null);

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const term = searchTerm;
            if (term.length >= 3) {
                const filtered = totalPositions.filter(item => (
                    (item.date && item.date.toLowerCase().includes(term.toLowerCase())) ||
                    (item.url && item.url.toLowerCase().includes(term.toLowerCase())) ||
                    (item.intern_name && item.intern_name.toLowerCase().includes(term.toLowerCase())) ||
                    (item.address && item.address.toLowerCase().includes(term.toLowerCase())) ||
                    (item.name_1 && item.name_1.toLowerCase().includes(term.toLowerCase())) ||
                    (item.branch_names && item.branch_names.toLowerCase().includes(term.toLowerCase())) ||
                    (item.city && item.city.toLowerCase().includes(term.toLowerCase())) ||
                    (item.version && item.version.toLowerCase().includes(term.toLowerCase())) ||
                    (item.firm && item.firm.toLowerCase().includes(term.toLowerCase())) ||
                    (item.server && item.server.toLowerCase().includes(term.toLowerCase())) ||
                    (item.username && item.username.toLowerCase().includes(term.toLowerCase())) ||
                    (item.title && item.title.toLowerCase().includes(term.toLowerCase())) ||
                    (item.order_id && item.order_id.toString().includes(term))
                ));
                setPublished(filtered);
            } else {
                setPublished(totalPositions);
            }
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm, totalPositions, setPublished]);

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const clearSearch = () => {
        setSearchTerm('');
        inputRef.current.focus();
    };

    return (
        <div style={{ position: "sticky", top: 0, zIndex: 1 }}>
            <div className="search-bar">
                {
                    positionLabel && (
                        <h2><span className={'color-white'}>{positionLabel}</span></h2>
                    )
                }
                <div className="p-15" style={{ position: 'relative' }}>
                    <input
                        id="search"
                        ref={inputRef}
                        className="form-control search-form"
                        type="search"
                        autoFocus={autoFocus}
                        placeholder="Rechercher..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    {searchTerm && (
                        <button
                            onClick={clearSearch}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '24px',
                            }}
                        >
                            &times;
                        </button>
                    )}
                </div>
                <p className={'positions-found'}>
                    {totalPositionsLength.length} {searchLabel}
                </p>
                <div className="display-flex justify-end gap-10 p-15">
                    <button className={"button-third"} onClick={!loading ? updateWebsites : null}>
                        <i className="fa-solid fa-sync mr-5"></i>
                        {loading ? "Mise à jour en cours..." : "Mettre à jour"}
                    </button>
                    <button className={"button-third"} onClick={!loading ? handleRunMonitoringScan : null}>
                        <i className="fa-solid fa-tower-broadcast mr-5"></i>
                        {loading ? "Scan en cours..." : "Lancer un scan des sites en ligne"}
                    </button>
                    <button className={"button-third"} onClick={!loading ? handleRunSecurityScan : null}>
                        <i className="fa-solid fa-shield-halved mr-5"></i>
                        {loading ? "Scan en cours..." : "Lancer un scan de sécurité"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default React.memo(SearchBarPublished);
